import { useEffect, useState } from "react";
import styles from "../../Styles/landing.module.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { error } from "../../Utils/notification";
import safty from "../../Images/safetyplus.svg"

function Slider() {
  const [hover, sethover] = useState(false);
  const [source, setsource] = useState("");
  const [destination, setdestination] = useState("");
  const [date, setdate] = useState("");
  const [showName, setShowNames] = useState(false);
  const [showNamedes, setShowNamesdes] = useState(false);
  const [output, setOutput] = useState([]);
  const [outputdes, setOutputdes] = useState([]);
  const [dateinfo, setdateinfo] = useState({});
  const [cityClicked, setCityclicked] = useState(false);
  const [CityDesclicked, setCityDesclicked] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    let mindate = new Date().toISOString().split("T")[0];
    let maxdate = new Date().toISOString().split("T")[0];
    // console.log(mindate, maxdate);
    setdate(mindate);
    setdateinfo({
      ...dateinfo,
      mindate: mindate,
      maxdate: maxdate,
    });
  }, []);

  useEffect(() => {
    if (source === "") {
      setShowNames(false);
      return;
    }
    if (cityClicked === true) {
      setCityclicked(false);
      return;
    }
    let timerID = setTimeout(() => {
      handleGetRequest();
    }, 1000);

    return () => {
      clearTimeout(timerID);
    };
  }, [source]);

  useEffect(() => {
    if (destination === "") {
      setShowNamesdes(false);
      return;
    }
    if (CityDesclicked === true) {
      setCityDesclicked(false);
      return;
    }
    let timerID = setTimeout(() => {
      handleGetRequestdes();
    }, 1000);

    return () => {
      clearTimeout(timerID);
    };
  }, [destination]);

  const handleGetRequest = async () => {
    try {
      let res = await axios.post("https://dream-travels.onrender.com/city", {
        source,
      });
      res = res.data;
      res= [{
        "_id": {
          "$oid": "640082f21efcfc116f406aee"
        },
        "name": "Mumbai",
        "state": "Maharashtra"
      },{
        "_id": {
          "$oid": "640082f21efcfc116f406aef"
        },
        "name": "Delhi",
        "state": "Delhi"
      },{
        "_id": {
          "$oid": "640082f21efcfc116f406af0"
        },
        "name": "Bengaluru",
        "state": "Karnataka"
      },{
        "_id": {
          "$oid": "640082f21efcfc116f406af1"
        },
        "name": "Ahmedabad",
        "state": "Gujarat"
      },{
        "_id": {
          "$oid": "640082f21efcfc116f406af2"
        },
        "name": "Hyderabad",
        "state": "Telangana"
      },{
        "_id": {
          "$oid": "640082f21efcfc116f406af3"
        },
        "name": "Chennai",
        "state": "Tamil Nadu"
      },{
        "_id": {
          "$oid": "640082f21efcfc116f406af4"
        },
        "name": "Kolkata",
        "state": "West Bengal"
      },{
        "_id": {
          "$oid": "640082f21efcfc116f406af5"
        },
        "name": "Pune",
        "state": "Maharashtra"
      },{
        "_id": {
          "$oid": "640082f21efcfc116f406af6"
        },
        "name": "Jaipur",
        "state": "Rajasthan"
      },{
        "_id": {
          "$oid": "640082f21efcfc116f406af7"
        },
        "name": "Surat",
        "state": "Gujarat"
      },{
        "_id": {
          "$oid": "640082f21efcfc116f406af8"
        },
        "name": "Lucknow",
        "state": "Uttar Pradesh"
      },{
        "_id": {
          "$oid": "640082f21efcfc116f406af9"
        },
        "name": "Kanpur",
        "state": "Uttar Pradesh"
      },{
        "_id": {
          "$oid": "640082f21efcfc116f406afa"
        },
        "name": "Nagpur",
        "state": "Maharashtra"
      },{
        "_id": {
          "$oid": "640082f21efcfc116f406afb"
        },
        "name": "Patna",
        "state": "Bihar"
      },{
        "_id": {
          "$oid": "640082f21efcfc116f406afc"
        },
        "name": "Indore",
        "state": "Madhya Pradesh"
      },{
        "_id": {
          "$oid": "640082f21efcfc116f406afd"
        },
        "name": "Thane",
        "state": "Maharashtra"
      },{
        "_id": {
          "$oid": "640082f21efcfc116f406afe"
        },
        "name": "Bhopal",
        "state": "Madhya Pradesh"
      }];
      setOutput(res);
      setShowNames(true);
      // console.log(output);
    } catch (err) {
      console.log(err);
    }
  };

  const handleGetRequestdes = async () => {
    try {
      let res = await axios.post("https://dream-travels.onrender.com/city", {
        destination,
      });

      res = res.data;
      res = [{
        "_id": {
          "$oid": "640082f21efcfc116f406aee"
        },
        "name": "Mumbai",
        "state": "Maharashtra"
      },{
        "_id": {
          "$oid": "640082f21efcfc116f406aef"
        },
        "name": "Delhi",
        "state": "Delhi"
      },{
        "_id": {
          "$oid": "640082f21efcfc116f406af0"
        },
        "name": "Bengaluru",
        "state": "Karnataka"
      },{
        "_id": {
          "$oid": "640082f21efcfc116f406af1"
        },
        "name": "Ahmedabad",
        "state": "Gujarat"
      },{
        "_id": {
          "$oid": "640082f21efcfc116f406af2"
        },
        "name": "Hyderabad",
        "state": "Telangana"
      },{
        "_id": {
          "$oid": "640082f21efcfc116f406af3"
        },
        "name": "Chennai",
        "state": "Tamil Nadu"
      },{
        "_id": {
          "$oid": "640082f21efcfc116f406af4"
        },
        "name": "Kolkata",
        "state": "West Bengal"
      },{
        "_id": {
          "$oid": "640082f21efcfc116f406af5"
        },
        "name": "Pune",
        "state": "Maharashtra"
      },{
        "_id": {
          "$oid": "640082f21efcfc116f406af6"
        },
        "name": "Jaipur",
        "state": "Rajasthan"
      },{
        "_id": {
          "$oid": "640082f21efcfc116f406af7"
        },
        "name": "Surat",
        "state": "Gujarat"
      },{
        "_id": {
          "$oid": "640082f21efcfc116f406af8"
        },
        "name": "Lucknow",
        "state": "Uttar Pradesh"
      },{
        "_id": {
          "$oid": "640082f21efcfc116f406af9"
        },
        "name": "Kanpur",
        "state": "Uttar Pradesh"
      },{
        "_id": {
          "$oid": "640082f21efcfc116f406afa"
        },
        "name": "Nagpur",
        "state": "Maharashtra"
      },{
        "_id": {
          "$oid": "640082f21efcfc116f406afb"
        },
        "name": "Patna",
        "state": "Bihar"
      },{
        "_id": {
          "$oid": "640082f21efcfc116f406afc"
        },
        "name": "Indore",
        "state": "Madhya Pradesh"
      },{
        "_id": {
          "$oid": "640082f21efcfc116f406afd"
        },
        "name": "Thane",
        "state": "Maharashtra"
      },{
        "_id": {
          "$oid": "640082f21efcfc116f406afe"
        },
        "name": "Bhopal",
        "state": "Madhya Pradesh"
      }];
      setOutputdes(res);
      setShowNamesdes(true);
    } catch (err) {
      console.log(err);
    }
  };

  function handelhover() {
    sethover(true);
  }

  function handelhoverout() {
    sethover(false);
  }

  function handleclicked() {
    if (date === "" || destination === "" || source === "") {
      error("Please Fill All The Details");
      return;
    }
    if (source === destination) {
      error("Source And Destination Can't Be Same");
      return;
    }
    setsource("");
    getcityinfo(source, destination, date);
  }

  async function getcityinfo(source, destination, date) {
    try {
      let res = await axios.post("https://dream-travels.onrender.com/city/showcity", {
        source,
        destination,
        date,
      });
      if (res.data.status === "success") {
        navigate({
          pathname: "/bus/selectbus",
          search: `?from=${source}&to=${destination}&date=${date}`,
        });
      } else {
        setsource("");
        setdestination("");
        error("City Not Found");
      }
    } catch (error) {
      console.log(error);
    }
  }

  function handlecityclicked(name) {
    setCityclicked(true);
    setsource(name);
    setShowNames(false);
  }
  function handlecityclicked1(name) {
    setCityDesclicked(true);
    setdestination(name);
    setShowNamesdes(false);
  }

  function handledateclicked() {
    setShowNamesdes(false);
    setShowNames(false);
  }
  return (
    <>
      <div className={styles.Carousel}>
        <div
          id="carouselExampleAutoplaying"
          className="carousel slide"
          data-bs-ride="carousel"
        >
          <div className="carousel-inner" style={{opacity:'0.6'}}>

            <div className="carousel-item active" data-bs-interval="3000">
              {" "}
              <img
                src={require("../../Images/bus1.jpg")}
                className="object-fit-cover"
                style={{ height: "75vh", width: "100%" }}
                alt="..."
                onMouseOver={handelhover}
                onMouseLeave={handelhoverout}
              />
            </div>
            <div className="carousel-item" data-bs-interval="3000">
              {" "}
              <img
                src={require("../../Images/bus2.jpg")}
                className="object-fit-cover"
                alt="..."
                style={{ height: "75vh", width: "100%" }}
                onMouseOver={handelhover}
                onMouseLeave={handelhoverout}
              />
            </div>
            <div className="carousel-item" data-bs-interval="3000">
              {" "}
              <img
                src={require("../../Images/bus4.jpg")}
                className="object-fit-cover"
                alt="..."
                style={{ height: "75vh", width: "100%" }}
                onMouseOver={handelhover}
                onMouseLeave={handelhoverout}
              />
            </div>
          </div>
          {hover ? (
            <button
              className="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleAutoplaying"
              data-bs-slide="prev"
              onMouseOver={handelhover}
            >
              <span
                className="carousel-control-prev-icon"
                aria-hidden="true"
              ></span>
              <span className="visually-hidden">Previous</span>
            </button>
          ) : (
            <span className="visually-hidden">Previous</span>
          )}
          {hover ? (
            <button
              className="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleAutoplaying"
              data-bs-slide="next"
              onMouseOver={handelhover}
            >
              <span
                className="carousel-control-next-icon"
                aria-hidden="true"
              ></span>
              <span className="visually-hidden">Next</span>
            </button>
          ) : (
            <span className="visually-hidden">Next</span>
          )}
        </div>
        <div className={styles.data} style={{background:'white',padding:'10px',borderRadius:'10px'}}>
          <input
            type="text"
            placeholder="Source"
            value={source}
            onChange={(e) => {
              setsource(e.target.value);
              setShowNamesdes(false);
            }}
            className={styles.inputsource}
          />
          {showName && output.length != 0 && (
            <div className={styles.names}>
              {output?.map((item, i) => (
                <div
                  style={{ cursor: "pointer" }}
                  onClick={() => handlecityclicked(item.name)}
                  key={i}
                >
                  <h6 style={{ paddingTop: "5px", paddingLeft: "5px" }}>
                    {item.name},{item.state}
                  </h6>
                  <hr />
                </div>
              ))}
            </div>
          )}
          <input
            type="text"
            placeholder="Destination"
            value={destination}
            onChange={(e) => {
              setdestination(e.target.value);
              setShowNames(false);
            }}
            className={styles.inputsource1}
          />
          {showNamedes && outputdes.length != 0 && (
            <div className={styles.names1}>
              {outputdes?.map((item, i) => (
                <div
                  style={{ cursor: "pointer" }}
                  onClick={() => handlecityclicked1(item.name)}
                  key={i}
                >
                  <h6 style={{ paddingTop: "5px", paddingLeft: "5px" }}>
                    {item.name},{item.state}
                  </h6>
                  <hr />
                </div>
              ))}
            </div>
          )}
          <input
            type="date"
            value={date}
            min={dateinfo.mindate}
            onChange={(e) => setdate(e.target.value)}
            onClick={() => handledateclicked()}
          />
          <button onClick={handleclicked}>Search</button>
        </div>
        <div className={styles.infodiv}>
          <div>
            {" "}
            <img
              src={safty}
              alt="shield"
            />
          </div>
          <div>
            <h4>Introducing Safety+ Program</h4>
            <p>
              A unique certification program that ensures safety in all buses
            </p>
          </div>
          <div>
            <div>
              {" "}
              <button>know More</button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Slider;
